<template>
  <div>
    <!-- table principal -->
    <el-row type="flex" justify="end">
      <el-col :span="4">
        <div class="box mr-5">
          <el-select
            v-model="select"
            clearable
            placeholder="Todos"
            size="mini"
            @change="Filtropordepartamento"
            class="selector"
            default-first-option
          >
            <el-option key="1" label="Vendedores" value="32"></el-option>
            <el-option
              key="2"
              label="Servicios al Cliente"
              value="47"
            ></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <!-- <h1>KPI VENTAS</h1> -->
        <yearcomponent @change="handler_year" class="box-item"></yearcomponent>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-table2
          :columns="columns2"
          :show-summary="true"
          :summary-method="getTotalByMonthDeals"
          :default-items="items"
          :paginateFromApi="false"
          v-loading="principalTable"
        />
      </el-col>
    </el-row>

    <!-- table detalle por Vendedor -->
    <DetailDealsKpi ref="details" />
  </div>
</template>

<script>
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import { Months, commentColumns } from "../../../../helpers/SalesKpiColumns";
import { getTotalByMonthDeals } from "../../../../helpers/TableRabbeyTools";
import DetailDealsKpi from "./DetailDealsKpi.vue";

export default {
  name: "DealsKpi",
  components: { DetailDealsKpi, yearcomponent },
  data() {
    return {
      principalTable: true,
      loadingDetails: true,
      deals: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",
      TypeAgent: "customerservice",
      type: "Cantidad",
      SellerName: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      MontlyTarget: "",
      AccountNumber: "",
      InvoiceNum: "",
      ContactEmail: "",
      numToMonths: {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December"
      },
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },

      columns: [
        {
          prop: "SellerName",
          name: "Vendedor",
          minWidth: 220,
          fixed: true
        },
        ...Months
      ],
      columns2: [
        {
          prop: "SellerName",
          name: "Vendedor",
          minWidth: 220,
          fixed: true
        },
        ...this.mapOb(Months)
      ],

      columnsComments: [...commentColumns],
      items: [],
      comments: [],
      Dcoments: false,
      commentloading: false
    };
  },
  created() {
    this.getData();
  },
  computed: {
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    }
  },
  methods: {
    getTotalByMonthDeals,
    openDetail(mes, row) {
      // console.log(mes);
      this.$refs.details.show(
        row,
        mes,
        this.year,
        row[this.numToMonths[mes] + "Rate"]
      );
      // console.log("este es el row", row);
    },
    getTest() {
      return this.type;
    },
    mapOb(data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.cellAtrrs = {
          getTest: this.getTest,
          openDetail: this.openDetail,
          ...element.cellAtrrs
        };
      }
      return data;
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },

    handlerChanges() {
      this.getData();
    },

    getData() {
      // let url = "/api/SalesKpiApi/SummaryGrupedByMoths";
      let url = "/api/SalesKpiApi/SummaryGrupedByMoths2";
      let params = {
        year: this.year,
        CompanyId: this.currentCompany
      };
      this.$store.commit("rabbey_table/loading");
      this.$http
        .get(url, {
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          // console.log(this.items);
          this.$store.commit("rabbey_table/items", data);
        })
        .finally(() => {
          this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    },
    async Filtropordepartamento(selectvalue) {
      if (selectvalue) {
        this.items;
      } else {
        this.fetchReport();
      }
      // this.report.filter(x=>x.DeparmentId==)
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
